"use strict";

var _interopRequireDefault = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _interopRequireWildcard2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/interopRequireWildcard.js"));
var _regenerator2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.array.find-index");
require("core-js/modules/web.dom.iterable");
var _order = require("@/api/order");
var _orderForm = _interopRequireDefault(require("@/views/mall/components/orderForm"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _multiLanguageDisplay = require("@/utils/multiLanguageDisplay");
var _moment = _interopRequireDefault(require("moment"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Secondary package based on el-pagination
// 权限判断函数

var statusMap = {
  101: '未付款',
  102: '用户取消',
  103: '系统取消',
  104: '未付定金',
  105: '未付尾款',
  201: '已付款',
  202: '申请退款',
  203: '已退款',
  301: '已发货',
  302: '部分发货',
  401: '用户收货',
  402: '系统收货',
  403: '已关闭'
};
var typesMap = {
  0: '退款',
  1: '退货退款',
  2: '换货'
};
var goodStatusMap = {
  101: '售后中',
  102: '已取消',
  201: '已完成',
  202: '已拒绝',
  203: '退货中',
  301: '已退款'
};
var _default = exports.default = (0, _defineProperty2.default)((0, _defineProperty2.default)({
  name: 'MallOrder',
  components: {
    Pagination: _Pagination.default
  },
  filters: {
    orderStatusFilter: function orderStatusFilter(status) {
      return statusMap[status];
    },
    orderTypesFilter: function orderTypesFilter(type) {
      return typesMap[type];
    },
    goodStatusFilter: function goodStatusFilter(status) {
      return goodStatusMap[status];
    }
  },
  data: function data() {
    return {
      list: [],
      visible: false,
      total: 0,
      status: [{
        label: "无需审核",
        value: 1
      }, {
        label: "待审核",
        value: 2
      }, {
        label: "审核通过",
        value: 3
      }, {
        label: "审核不通过",
        value: 4
      }],
      orderType: [{
        label: "无需审核",
        value: 1
      }, {
        label: "待审核",
        value: 2
      }, {
        label: "审核通过",
        value: 3
      }, {
        label: "审核不通过",
        value: 4
      }],
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 20,
        sort: 'add_time',
        order: 'desc',
        auditstatus: null,
        id: undefined,
        name: undefined,
        showType: '0'
      },
      info: {},
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      channels: [],
      tab: '0',
      statusMap: statusMap,
      // 订单详情
      orderDialogVisible: false,
      orderDetail: {
        order: {},
        user: {},
        orderGoods: []
      },
      // 发货
      shipForm: {
        orderId: undefined,
        shipChannel: undefined,
        shipSn: undefined,
        orderGoodsIds: []
      },
      shipDialogVisible: false,
      shipRules: {
        shipChannel: [{
          required: true,
          message: '快递公司不能为空',
          trigger: 'blur'
        }],
        shipSn: [{
          required: true,
          message: '快递编号不能为空',
          trigger: 'blur'
        }]
      },
      goodsList: [],
      multipleSelection: [],
      // 导出
      downloadLoading: false
    };
  },
  created: function created() {
    if (this.$route.query.tab) {
      this.tab = this.$route.query.tab;
      this.listQuery.showType = this.$route.query.tab;
    }
    this.getList();
    this.getChannel();
  }
}, "components", {
  OrderForm: _orderForm.default,
  Pagination: _Pagination.default
}), "methods", {
  multiLanguageDisplay: _multiLanguageDisplay.multiLanguageDisplay,
  checkPermission: _permission.default,
  getText3: function getText3(str) {
    var _this2 = this;
    var a = [];
    if (!str) return a;
    str.forEach(function (item) {
      console.log(_this2.multiLanguageDisplay(item), 'this.multiLanguageDisplay(item)');
      a.push(_this2.multiLanguageDisplay(item));
    });
    return a.join(",");
  },
  refresh: function refresh() {
    this.getList();
  },
  getText: function getText(val) {
    try {
      var index = this.status.findIndex(function (item) {
        return item['value'] == val;
      });
      return this.status[index]['label'];
    } catch (error) {
      return '';
    }
  },
  getText2: function getText2(val) {
    try {
      var index = this.orderType.findIndex(function (item) {
        return item['value'] == val;
      });
      return this.orderType[index]['label'];
    } catch (error) {
      return '';
    }
  },
  handleSh: function () {
    var _handleSh = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(row) {
      return (0, _regenerator2.default)().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            console.log(row, 'row');
            this.visible = true;
            this.info = row;
          case 1:
            return _context.a(2);
        }
      }, _callee, this);
    }));
    function handleSh(_x) {
      return _handleSh.apply(this, arguments);
    }
    return handleSh;
  }(),
  // 获取订单列表
  getList: function getList() {
    var _this3 = this;
    this.listLoading = true;
    var data = JSON.parse(JSON.stringify(this.listQuery));
    if (data.timeArray && data.timeArray.length === 2) {
      data.start = (0, _moment.default)(data.timeArray[0]).format('YYYY-MM-DD HH:mm:ss');
      data.end = (0, _moment.default)(data.timeArray[1]).format('YYYY-MM-DD HH:mm:ss');
    } else {
      data.start = null;
      data.end = null;
    }
    delete data.timeArray;
    (0, _order.listOrder)(data).then(function (response) {
      _this3.list = response.data.data.list;
      _this3.total = response.data.data.total;
      _this3.listLoading = false;
    }).catch(function () {
      _this3.list = [];
      _this3.total = 0;
      _this3.listLoading = false;
    });
  },
  // 获取快递公司列表
  getChannel: function getChannel() {
    var _this4 = this;
    (0, _order.listChannel)().then(function (response) {
      _this4.channels = response.data.data;
    });
  },
  // 表格Tab点击事件
  handleClick: function handleClick() {
    this.listQuery.showType = this.tab;
    this.getList();
  },
  // 查询
  handleFilter: function handleFilter() {
    this.listQuery.page = 1;
    this.getList();
  },
  // 详情
  handleDetail: function handleDetail(row) {
    this.$router.push({
      path: '/mall/orderdetail',
      query: {
        id: row.id
      }
    });
  },
  // 发货
  handleShip: function handleShip(row) {
    var _this5 = this;
    this.shipForm.orderId = row.id;
    this.shipForm.shipChannel = row.shipChannel;
    this.shipForm.shipSn = row.shipSn;
    this.shipForm.orderGoodsIds = [];
    (0, _order.listShipGoods)({
      orderId: row.id
    }).then(function (response) {
      _this5.goodsList = response.data.data;
      _this5.shipDialogVisible = true;
      _this5.$nextTick(function () {
        _this5.$refs['shipForm'].clearValidate();
      });
    });
  },
  handleSelectionChange: function handleSelectionChange(val) {
    this.multipleSelection = val;
  },
  confirmShip: function confirmShip() {
    var _this6 = this;
    if (this.multipleSelection.length === 0) {
      this.$message.error('发货商品不能为空');
      return;
    }
    var _this = this;
    this.multipleSelection.forEach(function (item, index, array) {
      _this.shipForm.orderGoodsIds.push(item.id);
    });
    this.$refs['shipForm'].validate(function (valid) {
      if (valid) {
        (0, _order.shipOrder)(_this6.shipForm).then(function (response) {
          _this6.shipDialogVisible = false;
          _this6.$notify.success({
            title: '成功',
            message: '确认发货成功'
          });
          _this6.getList();
        }).catch(function (response) {
          _this6.$notify.error({
            title: '失败',
            message: response.data.errmsg
          });
        });
      }
    });
  },
  // 删除
  handleDelete: function handleDelete(row) {
    var _this7 = this;
    this.$confirm('是否要进行删除操作?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(function () {
      (0, _order.deleteOrder)({
        orderId: row.id
      }).then(function (response) {
        _this7.$notify.success({
          title: '成功',
          message: '订单删除成功'
        });
        _this7.getList();
      }).catch(function (response) {
        _this7.$notify.error({
          title: '失败',
          message: response.data.errmsg
        });
      });
    });
  },
  // 导出表格
  handleDownload: function handleDownload() {
    var _this8 = this;
    this.downloadLoading = true;
    Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/vendor/Export2Excel'));
    }).then(function (excel) {
      var tHeader = ['订单ID', '订单编号', '用户ID', '订单状态', '是否删除', '收货人', '收货联系电话', '收货地址'];
      var filterVal = ['id', 'orderSn', 'accountId', 'orderStatus', 'isDelete', 'consignee', 'mobile', 'address'];
      excel.export_json_to_excel2(tHeader, _this8.list, filterVal, '订单信息');
      _this8.downloadLoading = false;
    });
  },
  // 打印
  printOrder: function printOrder() {
    this.$print(this.$refs.print);
    this.orderDialogVisible = false;
  }
});